import { authService } from '@guryou/utils';
import { handleError, handleSuccess, triggerGet } from './utils';
const getSubscriptionSessionsByCustomerId = async () => {
  const apiResponse = await triggerGet("/customer/subscriptions/".concat(authService.user.usersId, "/sessions/"));
  const responseData = await apiResponse.json();
  if ([200, 201].includes(responseData.report.status)) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};
const getCustomerSubscriptions = async () => {
  const apiResponse = await triggerGet("/customer/subscriptions/");
  const responseData = await apiResponse.json();
  if ([200, 201].includes(responseData.report.status)) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};
export { getCustomerSubscriptions, getSubscriptionSessionsByCustomerId };